<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader position-relative'>
                        <h2 id="titleHeight">{{this.getLanguage["SUB"]["AGC"]}}</h2>

                        <div class="custom_tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="tooltiptext tooltip-left" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="tooltiptext tooltip-left" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>

                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class='searchBox'>
                            <div class='searchCol' v-if="getUserInfo.AT !== 4">
                                <span class='searchLabel'>{{this.getLanguage["SEO"]["BN"]}} :</span>
                                <customtreeselect :multiple="false"
                                                  :options="dd_agentgroupfs"
                                                  :flat="true"
                                                  :defaultExpandLevel="Infinity"
                                                  :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                                  @input="AgentGroupChangefs" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["GL"]["SAGT"]}} :</span>
                                <treeselect :multiple="false"
                                            :async="true"
                                            :key="rtSubBrand"
                                            :load-options="loadSubBrandOptions"
                                            :cacheOptions="false"
                                            :defaultOptions="dd_DefaultSubBrand"
                                            :options="dd_subagentgroup"
                                            :disable-branch-nodes="true"
                                            :searchPromptText="this.getLanguage['GL']['DDTS']"
                                            :placeholder="this.utilGetDDLanguage('GL.SAGT')"
                                            :noResultsText="this.getLanguage['GL']['NRF']"
                                            v-model="str_FV[2].FV"
                                            openDirection="below"
                                            @input="SubAgentGroupChangefs" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['SD']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="left"
                                                   :auto-apply="true"
                                                   v-model="str_FV[1].FV"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="str_FV[1].FV.startDate != ''">
                                            <CInput size="sm"
                                                    :value="str_FV[1].FV.startDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['ED']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="left"
                                                   :auto-apply="true"
                                                   v-model="str_FV[1].FV"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="str_FV[1].FV.endDate != ''">
                                            <CInput size="sm"
                                                    :value="str_FV[1].FV.endDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                        
                        </div>
                        <div class='searchBtnCol'>
                            <CButton v-shortkey="['enter']" class='searchBtn' ref="search" size="sm" block color="success" @click=" newSearch()"><span class='searchIcon cil-search'></span><span>{{this.getLanguage["BTN"]["SR"]}}</span></CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>

            <div class='table-wrapper '>
                <header class="table-header d-flex">
                    <div class="d-md-flex align-items-center">
                        <strong id="titleHeight">{{this.getLanguage["SUB"]["AGCL"]}}</strong>
                    </div>

                    <div class="pageBtn">
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </header>

                <div class="custom-table-wrapper" id="tHead">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th>{{this.getLanguage["GL"]["NO"]}}</th>
                                <th>{{ this.getLanguage["GL"]["ACT"] }}</th>
                                <th>
                                    <div class="d-inline-block">
                                        <span class="grid-line">{{ this.getLanguage["AG"]["PG"] }}</span>
                                        <span class="grid-line">({{ this.getLanguage["AG"]["PC"] }})</span>
                                    </div>
                                </th>
                                <th>
                                    <div class="d-inline-block">
                                        <span class="grid-line">{{ this.getLanguage["AG"]["GN"] }}</span>
                                        <span class="grid-line">({{ this.getLanguage["AG"]["PC"] }})</span>
                                    </div>
                                    <i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo" style="margin-top: 9px;"></i>
                                </th>
                                <th>
                                    {{ this.getLanguage["DM"]["D"] }}
                                    <i @click="setSortTable('DU')" :class="setSortLogo('DU')" class="sortlogo"></i>
                                </th>
                                <th>
                                    {{ this.getLanguage["MEM"]["U"] }}
                                    <i @click="setSortTable('U')" :class="setSortLogo('U')" class="sortlogo"></i>
                                </th>
                                <th>
                                    {{ this.getLanguage["AG"]["DC"] }}
                                    <i @click="setSortTable('CI')" :class="setSortLogo('CI')" class="sortlogo"></i>
                                </th>
                                <th>
                                    {{ this.getLanguage["MEM"]["DN"] }}
                                    <i @click="setSortTable('DU')" :class="setSortLogo('DU')" class="sortlogo"></i>
                                </th>
                                <th>
                                    {{ this.getLanguage["MEM"]["E"] }}
                                    <i @click="setSortTable('E')" :class="setSortLogo('E')" class="sortlogo"></i>
                                </th>
                                <th>
                                    {{ this.getLanguage["MEM"]["PN"] }}
                                    <i @click="setSortTable('PN')" :class="setSortLogo('PN')" class="sortlogo"></i>
                                </th>
                                <th>
                                    <div class="d-inline-block">
                                        <span class="grid-line">{{ this.getLanguage["CR"]["CB"] }}</span>
                                        <span class="grid-line">
                                            {{ this.getLanguage["GL"]["CT"] }}
                                            <i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo"></i>
                                        </span>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th>{{this.getLanguage["GL"]["NO"]}}</th>
                                <th>{{ this.getLanguage["GL"]["ACT"] }}</th>
                                <th>
                                    <div class="d-inline-block">
                                        <span class="grid-line">{{ this.getLanguage["AG"]["PG"] }}</span>
                                        <span class="grid-line">({{ this.getLanguage["AG"]["PC"] }})</span>
                                    </div>
                                </th>
                                <th>
                                    <div class="d-inline-block">
                                        <span class="grid-line">{{ this.getLanguage["AG"]["GN"] }}</span>
                                        <span class="grid-line">({{ this.getLanguage["AG"]["PC"] }})</span>
                                    </div>
                                    <i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo" style="margin-top: 9px;"></i>
                                </th>
                                <th>
                                    {{ this.getLanguage["DM"]["D"] }}
                                    <i @click="setSortTable('DU')" :class="setSortLogo('DU')" class="sortlogo"></i>
                                </th>
                                <th>
                                    {{ this.getLanguage["MEM"]["U"] }}
                                    <i @click="setSortTable('U')" :class="setSortLogo('U')" class="sortlogo"></i>
                                </th>
                                <th>
                                    {{ this.getLanguage["AG"]["DC"] }}
                                    <i @click="setSortTable('CI')" :class="setSortLogo('CI')" class="sortlogo"></i>
                                </th>
                                <th>
                                    {{ this.getLanguage["MEM"]["DN"] }}
                                    <i @click="setSortTable('DU')" :class="setSortLogo('DU')" class="sortlogo"></i>
                                </th>
                                <th>
                                    {{ this.getLanguage["MEM"]["E"] }}
                                    <i @click="setSortTable('E')" :class="setSortLogo('E')" class="sortlogo"></i>
                                </th>
                                <th>
                                    {{ this.getLanguage["MEM"]["PN"] }}
                                    <i @click="setSortTable('PN')" :class="setSortLogo('PN')" class="sortlogo"></i>
                                </th>
                                <th>
                                    <div class="d-inline-block">
                                        <span class="grid-line">{{ this.getLanguage["CR"]["CB"] }}</span>
                                        <span class="grid-line">
                                            {{ this.getLanguage["GL"]["CT"] }}
                                            <i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo"></i>
                                        </span>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if=" arr_Group.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <tr v-for="(data,index) in arr_Group">
                            <td>{{ CountItem(index+1) }}</td>
                            <td>
                                <span id="actionBtnCol">
                                    <CButton size="sm" type="button" class="btn-danger font-weight-bold text-white mr-2" @click="rejectGroup(data)" v-if="checkModuleAccess2(constAccessType.add)">
                                        {{getLanguage["GL"]["REJ"]}}
                                    </CButton>
                                    <CButton size="sm" type="button" class="btn-success font-weight-bold text-white mr-2" @click="approveGroup(data.I)" v-if="checkModuleAccess2(constAccessType.add)">
                                        {{getLanguage["GL"]["APR"]}}
                                    </CButton>
                                </span>
                            </td>
                            <td>
                                <div class="d-flex align-items-center">
                                    <div>
                                        <span class="grid-line">{{ data.PGN }}</span>
                                        <span class="grid-line">({{ data.PPC }})</span>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="d-flex align-items-center" v-if="data.AL > 0">
                                    <span class="mr-2">
                                        <i class=" " :class="[data.IOL?'fa-solid fa-house theme-outlet ml-2':'fas fa-users theme-subagent ml-2']"></i>
                                        <span v-if="data.AL!=0" :class="['subagent-icon', data.IOL?'outlet':'nonoutlet']">{{ data.AL.toString() }}</span>
                                    </span>
                                    <div>
                                        <span class="grid-line">{{ data.GN }}</span>
                                        <span class="grid-line">({{ data.PC }})</span>
                                    </div>
                                </div>
                                <div v-else>
                                    -
                                </div>
                            </td>
                            <td>{{data.DU}}</td>
                            <td>{{data.U}}</td>
                            <td>{{data.ISOC}}</td>
                            <td>{{data.DN}}</td>
                            <td>{{data.E}}</td>
                            <td>{{data.PN}}</td>
                            <td>
                                <div class="d-inline-block">
                                    <span class="grid-line">{{ data.CB }}</span>
                                    <span class="grid-line">{{ formatDateTime(data.CTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }} </span>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Treeselect from '@riophae/vue-treeselect';
    import { customtreeselect } from '@/views/CustomControl/index.js';
    import '@riophae/vue-treeselect/dist/vue-treeselect.css';
    import Loading from 'vue-loading-overlay';
    import DateRangePicker from 'vue2-daterange-picker';
    import moment from "moment";
    import 'vue-loading-overlay/dist/vue-loading.css';
    import { mapGetters, mapActions } from 'vuex'
    import genericHelper from "@/modules/GenericHelper.js";
    import { required, sameAs, requiredIf, alphaNum, minLength, maxLength, between, decimal, email, minValue } from 'vuelidate/lib/validators';
    import { constAccessType, constSubAgentSchemeType, constSubAgentType, loadingFullScreen } from '@/modules/Constant.js';
    import Vue from 'vue'
    import $ from 'jquery'
    //Vue.use(require('vue-shortkey'))

    export default {
        mixins: [genericHelper],
        components: {
            Treeselect,
            customtreeselect,
            Loading,
            DateRangePicker
        },
        data() {
            return {
                int_RC: 100, //Row Count
                int_Total: 0,
                int_Page: 1,
                int_IC: 1, // Item Count
                int_TP: 1, //Total Page
                str_tableSortBy: "CTS", //(sort the table col name)
                bool_isSort: true, // Table Ascending Descending
                //arr_FV: {
                //    "GN": "",
                //    "PC": "",
                //    "L": [],
                //    "AL": "",
                //    "AGI": null,
                //    "SAGAGI": null,
                //    "DR": {
                //        startDate: "",
                //        endDate: ""
                //    },
                //}, //Filter Value
                str_FV: [{ F: "AGI" }, { F: "CTS", FV: { startDate: "", endDate: "" } }, { F: "SAGAGI" }], //Filter Value
                bool_isAMV: false, // Add Modal Visible
                bool_fullLoading: false,
                bool_fullScreen: loadingFullScreen, //Full Screen
                arr_Group: [],
                obj_Group: {},
                bool_groupCV: false,
                constAccessType: constAccessType,
                dd_agentgroupfs: [],//agent group option
                dd_subagentgroup: [], //subagent group option
                dd_DefaultSubBrand: [],
                rtSubBrand: 0,
                bool_showSearchBar: true,
            }
        },
        validations: {
            obj_Group: {
                GN: { required },
                AT: { required },
                PGI: { required },
                DCI: { required },
                CA: { required },
                CurrencyIds: { required },
                SAGAGI: {
                    required: requiredIf(function (vm) {
                        if (!vm.PGIT) {
                            return false;
                        }
                        if (vm.PGIT.indexOf("-") > 0) {
                            var agi = vm.PGIT.split("-");

                            if (agi[0] == 4)
                                return true;
                            else
                                return false;
                        } else
                            return true;
                    })
                },
                PC: { required, minLength: minLength(8), maxLength: maxLength(8), alphaNum },
                Agent: {
                    U: {
                        required: requiredIf(function (vm) {
                            return vm.I == 0;
                        }),
                    },
                    UP: {
                        required: requiredIf(function (vm) {
                            return vm.I == 0;
                        }),
                        minLength: minLength(4)
                    },
                    CUP: {
                        required: requiredIf(function (vm) {
                            return vm.I == 0 && vm.UP != null && vm.UP != '';
                        }),
                        sameAsPassword: sameAs('UP')
                    },
                    DN: {
                        required: requiredIf(function (vm) {
                            return vm.I == 0;
                        }),
                    },
                    E: { email },
                },
                SubAgentPayoutScheme: {
                    PT: {
                        required,
                        between: function (val, obj) {
                            let res = true;
                            if (val) {
                                if (val < this.selectedMinPT || val > this.selectedMaxPT) {
                                    res = false;
                                }
                            }
                            return res;
                        }
                    },
                    WLT: { required },
                    POT: { required },
                },
            },
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['checkModuleAccess', 'getUserInfo']),
            ...mapGetters('CurrencyInfo', ['getThousandCurrency']),
        },
        watch: {
            bool_isAMV() {
                if (!this.bool_isAMV && this.bool_groupCV) {
                    this.showSuccessMessage(this.utilGetErrorLanguage("ERR.SS"), this.utilGetErrorLanguage("GL.AS"));
                }
            },
        },
        methods: {
            ...mapActions('SMBData', [
                'setCurrencySymbol',
                'setSystemBalance',
                'setCreditBalance'
            ]),
            ...mapActions('CurrencyInfo', ['setThousandCurrency']),
            DateTimeChange(type, event) {
                if (type == "SD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.arr_FV.DR.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.arr_FV.DR.startDate = "";
                    }
                }
                if (type == "ED") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.arr_FV.DR.endDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["ED"]), 1000);
                    } else {
                        this.arr_FV.DR.endDate = "";
                    }
                }
            },
            checkModuleAccess2(type) {
                return this.checkModuleAccess('SUB', 'AGS', type);
            },
            closeAdd() {
                this.bool_isAMV = !this.bool_isAMV;
                this.bool_groupCV = false;
            },
            ctrPage(newPage,inputValue = 1) {
                if (inputValue == 0) {
                    this.int_Page = Math.max(1, Math.min(newPage, this.int_TP));
                }
                else {
                    this.int_Page = (newPage > this.int_TP) ? 1 : (newPage < 1) ? this.int_TP : newPage;
                }
                this.int_IC = this.int_Page;
                this.getGroupList();
            },
            newSearch() {
                if (!this.bool_isAMV) {
                    this.$refs.search.focus();
                    this.int_Page = 1;
                    this.int_IC = 1;
                    this.getGroupList();
                }
            },
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                }
                else {
                    return value;
                }
            },
            setSortTable(SV) { //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isTAD}
                this.getGroupList();
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            getGroupList() {
                this.bool_fullLoading = true;

                var that = this;
                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);

                path += "&f.PC=";

                for (var i = 0; i < this.str_FV.length; i++) {
                    if (this.str_FV[i].FV && i != 0 && i != 2) {

                        if (this.str_FV[i].FA && this.str_FV[i].FV) {
                            var temp_ = "";
                            for (var x = 0; x < this.str_FV[i].FV.length; x++) {
                                if (x != 0) {
                                    temp_ += ",";
                                }
                                var split = this.str_FV[i].FV[x].split("-");

                                if (split.length == 2) {
                                    temp_ += split[1];
                                }
                                else {
                                    temp_ += split[0];
                                }
                            }
                            path += ("&f[" + this.str_FV[i].F + "]=" + temp_);
                        }
                        else if (this.str_FV[i].F == 'CTS' && this.str_FV[i].FV != '') {
                            if (this.str_FV[i].FV.startDate != "") {
                                var cts_from = this.parseDateToJsonString(this.str_FV[i].FV.startDate);
                                path += "&f[CTS_from]=" + cts_from;
                            }
                            if (this.str_FV[i].FV.endDate != "") {
                                var cts_to = this.parseDateToJsonString(this.str_FV[i].FV.endDate);
                                path += "&f[CTS_to]=" + cts_to;
                            }
                        }
                        else {
                            path += ("&f[" + this.str_FV[i].F + "]=" + this.str_FV[i].FV);
                        }
                    }
                };

                //if (this.str_FV[2].FV) {
                //    path += "&f[AGI]=" + this.str_FV[2].FV;
                //} else if (this.str_FV[0].FV) {
                //    path += "&f[AGI]=" + this.str_FV[0].FV;
                //}

                if (this.str_FV[2].FV != null) {
                    path += "&f[ATAGI]=4-" + this.str_FV[2].FV
                } else if (this.str_FV[0].FV != null) {
                    path += "&f[ATAGI]=" + this.str_FV[0].FV
                }


                this.getDataApi(`/api/sag/lc?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;

                        if (s) {
                            that.int_TP = Math.max(d.D.TotalPages, 1);
                            that.int_Total = d.D.TotalItems;
                            that.arr_Group = d.D.Items;
                            that.resizeTableHead();
                        }
                    });
            },
            rejectGroup(data) {
                this.$fire({
                    title: this.getLanguage["MEM"]["CA"],
                    width: '30em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {
                        this.bool_fullLoading = true;
                        this.bool_fullScreen = true;
                        this.bool_groupCV = true;
                        var that = this;

                        this.obj_Group = {
                            "RS": 0,
                            "I": data.I,
                        };

                        this.postDataApi(`/api/sag/sc`, this.obj_Group,
                            function (d, s) {
                                that.bool_fullLoading = false;
                                that.bool_fullScreen = false;
                                if (s) {
                                    that.bool_isAMV = false;
                                    that.getGroupList();
                                }
                            });

                    }
                    else {
                    }
                });
            },
            approveGroup(id) {
                this.$fire({
                    title: this.getLanguage["MEM"]["CA"],
                    width: '30em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {
                        this.$router.push("/AGS/SUB?sagci=" + id);
                    }
                });
            },
            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");

                header.addEventListener("scroll", () => {
                    body.scrollLeft = header.scrollLeft;
                });

                body.addEventListener("scroll", () => {
                    header.scrollLeft = body.scrollLeft;
                });
            },
            calculateWidths() {
                $('#tHead, #tBody').scrollLeft(0);
                const tables = this.$el.querySelectorAll('#tBody .custom-table');
                const headerCells = this.$el.querySelectorAll('#tHead .custom-table thead tr:nth-child(1) th');

                if (!headerCells.length) return;

                tables.forEach((table) => {
                    const bodyCells = table.querySelectorAll('tbody tr:first-child td');
                    if (!bodyCells.length) return;

                    // Reset all widths
                    [...headerCells, ...table.querySelectorAll('tbody tr td')].forEach(cell => cell.style.width = '');

                    // Apply new widths
                    bodyCells.forEach((cell, index) => {
                        const width = `${cell.getBoundingClientRect().width}px`;
                        if (headerCells[index]) headerCells[index].style.width = width;
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach(td => td.style.width = width);
                    });
                });
            },
            initTableObserver() {
                const bodyTable = this.$el.querySelector('#tBody');

                // Observe changes in the body table
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                observer.observe(bodyTable, { childList: true, subtree: true });
                this.calculateWidths();
            },
            getAgentGroup() {
                var that = this;
                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s) {

                            that.dd_agentgroupfs = that.deepClone(d.dropdownlist);

                            if (that.dd_agentgroupfs.length > 0) {
                                that.dd_agentgroupfs.forEach(that.disableAgentGroupParent);
                            }
                        }
                    });
            },
            getSubAgentGroup(value, isFirstLoad = false) {
                var that = this;
                this.getDataApi(`/api/dd/subbrand/0/0/${value}/0/1`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.dd_DefaultSubBrand = that.deepClone(d.dropdownlist);

                            if (isFirstLoad) {
                                that.str_FV[2].FV = that.dd_DefaultSubBrand[0].id;
                                that.rtSubBrand = that.rtSubBrand == 0 ? 1 : 0;
                                that.getSEOList();
                            }
                        }
                    });
            },
            disableAgentGroupParent(item, index) {
                var agi = item.id.split("-");

                if (agi[0] != "3" && agi[0] != "4") {
                    item.isDisabled = true;
                }

                if (this.getUserInfo.AT == 0 && agi[0] == "0") {
                    item.isDisabled = false;
                }

                if (item.children && item.children.length > 0) {
                    item.children.forEach(this.disableAgentGroupParent);
                }
            },
            loadSubBrandOptions({ action, searchQuery, callback }) {
                var that = this;
                var parentAGI = 0;

                if (this.str_FV[0].FV && !this.bool_isAMV) {
                    var agentList = this.str_FV[0].FV.split("-");
                    parentAGI = agentList[agentList.length - 1];
                }
                else if (this.getUserInfo.AT === 4) {
                    parentAGI = 0;
                }
                else {
                    this.dd_subagentgroup = [];
                    callback(this.getLanguage['MEM']['PSAA']);
                }

                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.dd_subagentgroup = [];
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/subbrand/0/${searchQuery}/${parentAGI}/0/1`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.dd_subagentgroup = d.dropdownlist;
                                //that.bool_cacheOptionValue = true;
                            }
                            else {
                                that.dd_subagentgroup = [];
                            }
                            callback(null, that.dd_subagentgroup);
                        });
                }
            },
            AgentGroupChangefs(value) {
                this.dd_dofs = [];
                this.str_FV[2].FV = null;
                if (value != undefined) {
                    var that = this;
                    var agi = 0;

                    if (value != "") {
                        agi = value;
                        //agi = value.split("-")[1];
                    }

               
                    this.str_FV[0].FV = agi;
                    this.str_FV[2].FV = null;
                }
                else {
                    this.str_FV[0].FV = null;
                    this.str_FV[2].FV = null;
                }
            },
            SubAgentGroupChangefs(value) {
                if (value != undefined) {
                    var that = this;
                    var agi = 0;

                    if (value != "") {
                        agi = value;
                    }
                    that.str_FV[2].FV = agi;
                }
                else {
                }
                //this.str_FV[0].FV = null;
            },
        },
        created() {
            this.$parent.showSubMenu = 'AGS';
            this.$parent.showActiveMenu = 'AGS.SUBC';

            this.getAgentGroup();
            //this.getGroupList();
            this.isSENS = this.getUserInfo.ISENS;
            this.curAGI = this.getUserInfo.AGI;


            if (this.getUserInfo.AT == 4) {
                this.getSubAgentGroup(0, true);
            } else {
                this.getGroupList();
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/SideMenu/AgentSetting/CreateSubAgentCandidate.vue